// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '../stylesheets/application'
import '../order_form'
require('@rails/ujs').start()
require('turbolinks').start()
require('@rails/activestorage').start()
require('channels')

const $ = require('jquery')
global.$ = global.jQuery = $
require('datatables.net')
require('datatables.net-bs4')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const dataTables = []

document.addEventListener('turbolinks:load', () => {
  if (dataTables.length === 0 && $('.data-table').length !== 0) {
    $('.data-table').each((_, element) => {
      dataTables.push($(element).DataTable({
        pageLength: 50
      }))
    })
  }
})

document.addEventListener('turbolinks:before-cache', () => {
  while (dataTables.length !== 0) {
    dataTables.pop().destroy()
  }
})

document.addEventListener('turbolinks:load', function (event) {
  if (typeof gtag === 'function') {
    gtag('config', '<%= Rails.application.credentials.dig(:google_analytics) %>', {
      page_location: event.data.url
    })
  }
})

// Inline editing for custom recipients
document.addEventListener('turbolinks:load', function () {
  const editButtons = document.querySelectorAll('.edit-btn')

  editButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault()

      const recipientId = this.dataset.id
      const row = document.getElementById(`custom_recipient_${recipientId}`)
      const nameCell = row.querySelector('[data-field="name"]')
      const addressCell = row.querySelector('[data-field="address"]')
      const outOfTownCell = row.querySelector('[data-field="out_of_town"]')
      const actionsCell = row.querySelector('td:last-child')

      // Store original values
      const originalName = this.dataset.name || ''
      const originalAddress = this.dataset.address || ''
      const originalOutOfTown = this.dataset.out_of_town === 'true'

      // Replace with input fields
      nameCell.innerHTML = `<input type="text" class="form-control" id="name_${recipientId}" value="${originalName}">`
      addressCell.innerHTML = `<input type="text" class="form-control" id="address_${recipientId}" value="${originalAddress}">`
      outOfTownCell.innerHTML = `<input type="checkbox" id="out_of_town_${recipientId}" ${originalOutOfTown ? 'checked' : ''}>`

      // Replace action buttons with Save/Cancel
      actionsCell.innerHTML = `
        <button class="btn btn-success btn-sm save-btn" data-id="${recipientId}">Save</button>
        <button class="btn btn-secondary btn-sm cancel-btn" data-id="${recipientId}">Cancel</button>
      `

      // Add save handler
      actionsCell.querySelector('.save-btn').addEventListener('click', function () {
        const newName = document.getElementById(`name_${recipientId}`).value
        const newAddress = document.getElementById(`address_${recipientId}`).value
        const newOutOfTown = document.getElementById(`out_of_town_${recipientId}`).checked

        // Send AJAX request to update
        fetch(`/custom_recipients/${recipientId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({
            custom_recipient: {
              name: newName,
              address: newAddress,
              out_of_town: newOutOfTown
            }
          })
        })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
            // Restore the row with updated values
              const cr = data.custom_recipient
              nameCell.innerHTML = cr.name
              nameCell.classList.add('editable-field')
              nameCell.dataset.field = 'name'

              addressCell.innerHTML = cr.address
              addressCell.classList.add('editable-field')
              addressCell.dataset.field = 'address'

              outOfTownCell.innerHTML = `
              <input type="checkbox" 
                     name="out_of_town[]" 
                     value="custom_recipient_${cr.id}" 
                     ${cr.out_of_town ? 'checked' : ''} 
                     disabled="disabled">
            `
              outOfTownCell.classList.add('editable-field')
              outOfTownCell.dataset.field = 'out_of_town'

              actionsCell.innerHTML = `
              <a href="#" class="btn btn-primary btn-sm edit-btn" 
                 data-id="${cr.id}" 
                 data-name="${cr.name}" 
                 data-address="${cr.address}" 
                 data-out_of_town="${cr.out_of_town}">Edit</a>
              <a data-confirm="Are you sure you want to delete this custom recipient?" 
                 class="btn btn-danger btn-sm" 
                 rel="nofollow" 
                 data-method="delete" 
                 href="/custom_recipients/${cr.id}">Delete</a>
            `

              // Reattach event listener to the new edit button
              const newEditButton = actionsCell.querySelector('.edit-btn')
              attachEditHandler(newEditButton)

              // Show success message
              showFlashMessage('Custom recipient updated successfully.', 'success')
            } else {
              showFlashMessage(`Error: ${data.errors.join(', ')}`, 'danger')
            }
          })
          .catch(error => {
            console.error('Error:', error)
            showFlashMessage('An error occurred while updating.', 'danger')
          })
      })

      // Add cancel handler
      actionsCell.querySelector('.cancel-btn').addEventListener('click', function () {
        // Restore original values
        nameCell.innerHTML = originalName
        nameCell.classList.add('editable-field')
        nameCell.dataset.field = 'name'

        addressCell.innerHTML = originalAddress
        addressCell.classList.add('editable-field')
        addressCell.dataset.field = 'address'

        outOfTownCell.innerHTML = `
          <input type="checkbox" 
                 name="out_of_town[]" 
                 value="custom_recipient_${recipientId}" 
                 ${originalOutOfTown ? 'checked' : ''} 
                 disabled="disabled">
        `
        outOfTownCell.classList.add('editable-field')
        outOfTownCell.dataset.field = 'out_of_town'

        actionsCell.innerHTML = `
          <a href="#" class="btn btn-primary btn-sm edit-btn" 
             data-id="${recipientId}" 
             data-name="${originalName}" 
             data-address="${originalAddress}" 
             data-out_of_town="${originalOutOfTown}">Edit</a>
          <a data-confirm="Are you sure you want to delete this custom recipient?" 
             class="btn btn-danger btn-sm" 
             rel="nofollow" 
             data-method="delete" 
             href="/custom_recipients/${recipientId}">Delete</a>
        `

        // Reattach event listener to the new edit button
        const newEditButton = actionsCell.querySelector('.edit-btn')
        attachEditHandler(newEditButton)
      })
    })
  })

  function attachEditHandler (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault()

      const recipientId = this.dataset.id
      const row = document.getElementById(`custom_recipient_${recipientId}`)
      const nameCell = row.querySelector('[data-field="name"]')
      const addressCell = row.querySelector('[data-field="address"]')
      const outOfTownCell = row.querySelector('[data-field="out_of_town"]')
      const actionsCell = row.querySelector('td:last-child')

      // Store original values
      const originalName = this.dataset.name || ''
      const originalAddress = this.dataset.address || ''
      const originalOutOfTown = this.dataset.out_of_town === 'true'

      // Replace with input fields
      nameCell.innerHTML = `<input type="text" class="form-control" id="name_${recipientId}" value="${originalName}">`
      addressCell.innerHTML = `<input type="text" class="form-control" id="address_${recipientId}" value="${originalAddress}">`
      outOfTownCell.innerHTML = `<input type="checkbox" id="out_of_town_${recipientId}" ${originalOutOfTown ? 'checked' : ''}>`

      // Replace action buttons with Save/Cancel
      actionsCell.innerHTML = `
        <button class="btn btn-success btn-sm save-btn" data-id="${recipientId}">Save</button>
        <button class="btn btn-secondary btn-sm cancel-btn" data-id="${recipientId}">Cancel</button>
      `

      // Add save and cancel handlers (same as above)
      setupSaveHandler(actionsCell, recipientId, nameCell, addressCell, outOfTownCell, originalName, originalAddress, originalOutOfTown)
      setupCancelHandler(actionsCell, recipientId, nameCell, addressCell, outOfTownCell, originalName, originalAddress, originalOutOfTown)
    })
  }

  function setupSaveHandler (actionsCell, recipientId, nameCell, addressCell, outOfTownCell, originalName, originalAddress, originalOutOfTown) {
    actionsCell.querySelector('.save-btn').addEventListener('click', function () {
      const newName = document.getElementById(`name_${recipientId}`).value
      const newAddress = document.getElementById(`address_${recipientId}`).value
      const newOutOfTown = document.getElementById(`out_of_town_${recipientId}`).checked

      fetch(`/custom_recipients/${recipientId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          custom_recipient: {
            name: newName,
            address: newAddress,
            out_of_town: newOutOfTown
          }
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            const cr = data.custom_recipient
            restoreCell(nameCell, cr.name || '', 'name')
            restoreCell(addressCell, cr.address || '', 'address')
            restoreCheckbox(outOfTownCell, cr.id, cr.out_of_town)
            restoreActionButtons(actionsCell, cr.id, cr.name, cr.address, cr.out_of_town)
            showFlashMessage('Custom recipient updated successfully.', 'success')
          } else {
            showFlashMessage(`Error: ${data.errors.join(', ')}`, 'danger')
          }
        })
        .catch(error => {
          console.error('Error:', error)
          showFlashMessage('An error occurred while updating.', 'danger')
        })
    })
  }

  function setupCancelHandler (actionsCell, recipientId, nameCell, addressCell, outOfTownCell, originalName, originalAddress, originalOutOfTown) {
    actionsCell.querySelector('.cancel-btn').addEventListener('click', function () {
      restoreCell(nameCell, originalName, 'name')
      restoreCell(addressCell, originalAddress, 'address')
      restoreCheckbox(outOfTownCell, recipientId, originalOutOfTown)
      restoreActionButtons(actionsCell, recipientId, originalName, originalAddress, originalOutOfTown)
    })
  }

  function restoreCell (cell, value, field) {
    cell.innerHTML = value
    cell.classList.add('editable-field')
    cell.dataset.field = field
  }

  function restoreCheckbox (cell, id, checked) {
    cell.innerHTML = `
      <input type="checkbox" 
             name="out_of_town[]" 
             value="custom_recipient_${id}" 
             ${checked ? 'checked' : ''} 
             disabled="disabled">
    `
    cell.classList.add('editable-field')
    cell.dataset.field = 'out_of_town'
  }

  function restoreActionButtons (cell, id, name, address, outOfTown) {
    cell.innerHTML = `
      <a href="#" class="btn btn-primary btn-sm edit-btn" 
         data-id="${id}" 
         data-name="${name || ''}" 
         data-address="${address || ''}" 
         data-out_of_town="${outOfTown}">Edit</a>
      <a data-confirm="Are you sure you want to delete this custom recipient?" 
         class="btn btn-danger btn-sm" 
         rel="nofollow" 
         data-method="delete" 
         href="/custom_recipients/${id}">Delete</a>
    `
    const newEditButton = cell.querySelector('.edit-btn')
    attachEditHandler(newEditButton)
  }

  function showFlashMessage (message, type) {
    const flashDiv = document.createElement('div')
    flashDiv.className = `alert alert-${type} alert-dismissible fade show`
    flashDiv.role = 'alert'
    flashDiv.innerHTML = `
      ${message}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    `

    const container = document.querySelector('.container')
    if (container) {
      container.insertBefore(flashDiv, container.firstChild)

      setTimeout(() => {
        flashDiv.remove()
      }, 5000)
    }
  }

  // Inline editing for senders (name and email)
  const editSenderButtons = document.querySelectorAll('.edit-sender-btn')

  editSenderButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault()

      const senderId = this.dataset.id
      const row = document.getElementById(`sender_${senderId}`)
      const nameCell = row.querySelector('[data-field="name"]')
      const emailCell = row.querySelector('[data-field="email"]')
      const actionsCell = row.querySelector('td:last-child')

      // Store original values
      const originalName = this.dataset.name || ''
      const originalEmail = this.dataset.email || ''

      // Replace with input fields
      nameCell.innerHTML = `<input type="text" class="form-control" id="sender_name_${senderId}" value="${originalName}">`
      emailCell.innerHTML = `<input type="text" class="form-control" id="sender_email_${senderId}" value="${originalEmail}">`

      // Replace action buttons with Save/Cancel
      actionsCell.innerHTML = `
        <button class="btn btn-success btn-sm save-sender-btn" data-id="${senderId}">Save</button>
        <button class="btn btn-secondary btn-sm cancel-sender-btn" data-id="${senderId}">Cancel</button>
      `

      // Add save handler
      actionsCell.querySelector('.save-sender-btn').addEventListener('click', function () {
        const newName = document.getElementById(`sender_name_${senderId}`).value
        const newEmail = document.getElementById(`sender_email_${senderId}`).value

        // Send AJAX request to update
        fetch(`/senders/${senderId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({
            sender: {
              name: newName,
              email: newEmail
            }
          })
        })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
            // Restore the cells with updated values
              const s = data.sender
              nameCell.innerHTML = s.name
              nameCell.classList.add('editable-field')
              nameCell.dataset.field = 'name'

              emailCell.innerHTML = s.email
              emailCell.classList.add('editable-field')
              emailCell.dataset.field = 'email'

              actionsCell.innerHTML = `
              <a href="#" class="btn btn-primary btn-sm edit-sender-btn" 
                 data-id="${s.id}" 
                 data-name="${s.name}" 
                 data-email="${s.email}">Edit</a>
              <a data-confirm="Are you sure you want to delete this order? This will also delete all associated custom recipients." 
                 class="btn btn-danger btn-sm" 
                 rel="nofollow" 
                 data-method="delete" 
                 href="/senders/${s.id}">Delete</a>
            `

              // Reattach event listener to the new edit button
              const newEditButton = actionsCell.querySelector('.edit-sender-btn')
              attachSenderEditHandler(newEditButton)

              // Show success message
              showFlashMessage('Sender updated successfully.', 'success')
            } else {
              showFlashMessage(`Error: ${data.errors.join(', ')}`, 'danger')
            }
          })
          .catch(error => {
            console.error('Error:', error)
            showFlashMessage('An error occurred while updating.', 'danger')
          })
      })

      // Add cancel handler
      actionsCell.querySelector('.cancel-sender-btn').addEventListener('click', function () {
        // Restore original values
        nameCell.innerHTML = originalName
        nameCell.classList.add('editable-field')
        nameCell.dataset.field = 'name'

        emailCell.innerHTML = originalEmail
        emailCell.classList.add('editable-field')
        emailCell.dataset.field = 'email'

        actionsCell.innerHTML = `
          <a href="#" class="btn btn-primary btn-sm edit-sender-btn" 
             data-id="${senderId}" 
             data-name="${originalName}" 
             data-email="${originalEmail}">Edit</a>
          <a data-confirm="Are you sure you want to delete this order? This will also delete all associated custom recipients." 
             class="btn btn-danger btn-sm" 
             rel="nofollow" 
             data-method="delete" 
             href="/senders/${senderId}">Delete</a>
        `

        // Reattach event listener to the new edit button
        const newEditButton = actionsCell.querySelector('.edit-sender-btn')
        attachSenderEditHandler(newEditButton)
      })
    })
  })

  function attachSenderEditHandler (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault()

      const senderId = this.dataset.id
      const row = document.getElementById(`sender_${senderId}`)
      const nameCell = row.querySelector('[data-field="name"]')
      const emailCell = row.querySelector('[data-field="email"]')
      const actionsCell = row.querySelector('td:last-child')

      // Store original values
      const originalName = this.dataset.name || ''
      const originalEmail = this.dataset.email || ''

      // Replace with input fields
      nameCell.innerHTML = `<input type="text" class="form-control" id="sender_name_${senderId}" value="${originalName}">`
      emailCell.innerHTML = `<input type="text" class="form-control" id="sender_email_${senderId}" value="${originalEmail}">`

      // Replace action buttons with Save/Cancel
      actionsCell.innerHTML = `
        <button class="btn btn-success btn-sm save-sender-btn" data-id="${senderId}">Save</button>
        <button class="btn btn-secondary btn-sm cancel-sender-btn" data-id="${senderId}">Cancel</button>
      `

      // Add save and cancel handlers
      setupSenderSaveHandler(actionsCell, senderId, nameCell, emailCell, originalName, originalEmail)
      setupSenderCancelHandler(actionsCell, senderId, nameCell, emailCell, originalName, originalEmail)
    })
  }

  function setupSenderSaveHandler (actionsCell, senderId, nameCell, emailCell, originalName, originalEmail) {
    actionsCell.querySelector('.save-sender-btn').addEventListener('click', function () {
      const newName = document.getElementById(`sender_name_${senderId}`).value
      const newEmail = document.getElementById(`sender_email_${senderId}`).value

      fetch(`/senders/${senderId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          sender: {
            name: newName,
            email: newEmail
          }
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            const s = data.sender
            restoreSenderCell(nameCell, s.name, 'name')
            restoreSenderCell(emailCell, s.email, 'email')
            restoreSenderActionButtons(actionsCell, s.id, s.name, s.email)
            showFlashMessage('Sender updated successfully.', 'success')
          } else {
            showFlashMessage(`Error: ${data.errors.join(', ')}`, 'danger')
          }
        })
        .catch(error => {
          console.error('Error:', error)
          showFlashMessage('An error occurred while updating.', 'danger')
        })
    })
  }

  function setupSenderCancelHandler (actionsCell, senderId, nameCell, emailCell, originalName, originalEmail) {
    actionsCell.querySelector('.cancel-sender-btn').addEventListener('click', function () {
      restoreSenderCell(nameCell, originalName, 'name')
      restoreSenderCell(emailCell, originalEmail, 'email')
      restoreSenderActionButtons(actionsCell, senderId, originalName, originalEmail)
    })
  }

  function restoreSenderCell (cell, value, field) {
    cell.innerHTML = value
    cell.classList.add('editable-field')
    cell.dataset.field = field
  }

  function restoreSenderActionButtons (cell, id, name, email) {
    cell.innerHTML = `
      <a href="#" class="btn btn-primary btn-sm edit-sender-btn" 
         data-id="${id}" 
         data-name="${name || ''}" 
         data-email="${email || ''}">Edit</a>
      <a data-confirm="Are you sure you want to delete this order? This will also delete all associated custom recipients." 
         class="btn btn-danger btn-sm" 
         rel="nofollow" 
         data-method="delete" 
         href="/senders/${id}">Delete</a>
    `
    const newEditButton = cell.querySelector('.edit-sender-btn')
    attachSenderEditHandler(newEditButton)
  }
})
